import { Record as AuditRecord } from "@skinsoft/types";
import { SEARCH_TYPES } from "@skinsoft/const";

import { RecordDataStore as AuditRecordDataStore } from "@skinsoft/entity";
import { CACHE_KEYS, RecordOfflineDataFetcher as AuditRecordOfflineDataFetcher } from "@skinsoft/offline";
import { EntitySyncDownHandler } from "../../entity-sync-down-handler";

declare const config
const SEARCH_PAGE_SIZE = config.syncDownPageSize.auditRecord ?? config.syncDownPageSize.default

export class AuditRecordSyncDownHandler extends EntitySyncDownHandler<AuditRecord, AuditRecord, AuditRecord> {
    private static instance: AuditRecordSyncDownHandler = null as any

    public static getInstance() {
        if (!AuditRecordSyncDownHandler.instance) {
            AuditRecordSyncDownHandler.instance = new AuditRecordSyncDownHandler()
        }

        return AuditRecordSyncDownHandler.instance
    }

    public static install(Vue) {
        AuditRecordSyncDownHandler.getInstance()
    }

    constructor() {
        super(
            [SEARCH_TYPES.auditRecord],
            AuditRecordDataStore.getInstance(),
            new AuditRecordOfflineDataFetcher(CACHE_KEYS.AuditRecord),
            CACHE_KEYS.AuditRecord,
            SEARCH_PAGE_SIZE
        )
    }
}